import cn from 'classnames'

import StartNow from '../../exchange/how-to-exchange/start-now'

import styles from './styles.module.scss'
import Step1Icon from './icons/step1.svg'
import Step2Icon from './icons/step2.svg'
import Step3Icon from './icons/step3.svg'

import Step1Img from './images/step1Illustration.svg'
import Step2Img from './images/step2Illustration.svg'
import Step3Img from './images/step3Illustratiom.svg'
import { useTranslation } from 'utils/use-translation'

export default function GetReward() {
  const { t } = useTranslation()
  
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.wrapper__item}>
          <img className={styles.wrapper__item__number} src={Step1Icon} alt="number 1" />
          <img
            className={cn(styles.wrapper__item__bg, styles.wrapper__item__bg_first)}
            src={Step1Img}
            alt="background"
          />
          <h3>{t('get_link')}</h3>
          <p>{t('share_referral_link')}</p>
        </div>

        <div className={styles.wrapper__item}>
          <img className={styles.wrapper__item__number} src={Step2Icon} alt="number 2" />
          <img className={styles.wrapper__item__bg} src={Step2Img} alt="background" />
          <h3>{t('invite_friends')}</h3>
          <p>{t('invite_to_sign_up')}</p>
        </div>

        <div className={styles.wrapper__item}>
          <img className={styles.wrapper__item__number} src={Step3Icon} alt="number 3" />
          <img className={styles.wrapper__item__bg} src={Step3Img} alt="background" />
          <h3>{t('start_earning')}</h3>
          <p>{t('receive_up_to_02_while_active')}</p>
        </div>
      </div>

      <StartNow />
    </>
  )
}
